(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Huidige zoekresultaten',
    noCollectionFound: 'Collectie niet gevonden',
    allProducts: 'Zie alle producten',
    matching: 'Overeenkomend',
    sortBy: 'Gesorteerd op',
    relevance: 'Relevantie',
    outOf: 'van de',
    resultsFound: 'resultaten gevonden',
    oneResultFound: '1 resultaat gevonden',
    noResultFound: 'Geen resultaten gevonden',
    addToCart: 'Voeg toe aan winkelwagen',
    searchForProduct: 'Zoeken op producten',
    selectedFilter: 'Geselecteerde filters',
    clearAll: 'Verwijder alles',
    noPageFound: 'Geen pagina gevonden',
    outOfStock: 'Niet op voorraad',
    vendorDelivery: 'Verzending:',
    productDelivery: 'Verzending:',
    defaultDelivery: 'Voor 21:00 besteld, vandaag verzonden.',
    defaultOutOfStockDelivery: 'We laten het je weten als het product weer op voorraad is.',
    productInStock: 'Op voorraad.',
    productOutOfStock: 'Uitverkocht',
    new: 'Nieuw',
    soldOut: 'Uitverkocht',
    onSale: 'Aanbieding'
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Geen resultaten voor zoekopdracht ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Probeer ' +
        render(html_tags[0]) +
        ' andere filters ' +
        render(html_tags[1]) +
        ' of ' +
        render(html_tags[2]) +
        ' wijzig je zoekopdracht ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' van de'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
